import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import BlogService from "../../Service/BlogService";

const MultiAddressMap = ({ addresses }) => {
    const [positions, setPositions] = useState([]);
    const token = sessionStorage.getItem('token');


    const handleDeleteClick = async (id) => {
        try {
            await BlogService.deleteAdddress(id);
            window.location.reload();
        } catch (error) {
            console.error("Error deleting article:", error);
        }
    };

    useEffect(() => {
        const fetchCoordinates = async () => {
            const fetchedPositions = [];
            for (const address of addresses) {
                try {
                    const response = await fetch(
                        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address.adresse)}`
                    );
                    const data = await response.json();
                    if (data && data[0]) {
                        fetchedPositions.push({
                            address,
                            lat: parseFloat(data[0].lat),
                            lon: parseFloat(data[0].lon),
                        });
                    } else {
                        console.error(`Address not found: ${address}`);
                    }
                } catch (error) {
                    console.error(`Error fetching coordinates for ${address}:`, error);
                }
            }
            setPositions(fetchedPositions);
        };

        fetchCoordinates();
    }, [addresses]);

    return (
        <MapContainer center={[47.3674, 3.5127]} zoom={5} scrollWheelZoom={true}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {positions.map((pos, index) => (
                <Marker key={index} position={[pos.lat, pos.lon]}>
                    <Popup>{pos.address.adresse}
                        {token === '' && (
                            <button
                                className="inscription-button delete_button"
                                onClick={() => handleDeleteClick(pos.address.id)}
                                style={{ marginLeft: '10px', backgroundColor: 'red', color: 'white' }}
                            >
                                Supprimer
                            </button>
                        )}
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    );
};

export default MultiAddressMap;